export const getTimelineParallaxOptions = (node: HTMLElement) => ({
  ...getScrollTriggerParallaxOptions(node),
  defaults: { ease: 'none', duration: 1 }
})

export const getScrollTriggerParallaxOptions = (node: HTMLElement) => ({
  scrollTrigger: {
    trigger: node,
    horizontal: true,
    start: 'left 100%',
    scrub: true,
    markers: false
  }
})

export const getScrollTriggerTimelineOptions = (
  node: HTMLElement,
  reverse: boolean
) => ({
  scrollTrigger: {
    trigger: node,
    horizontal: true,
    start: 'left 82%',
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`,
    markers: false
  }
})
